// extracted by mini-css-extract-plugin
export default {"dark":"StatusPage_dark__PF0LQ","spinnerContainer":"StatusPage_spinnerContainer__Rvzfw","spinner":"StatusPage_spinner__95IN3","placeholder":"StatusPage_placeholder__G0nMF"};